
<template>
  <div>
    <vs-sidebar
      click-not-close
      parent="#email-app"
      :hidden-background="true"
      class="full-vs-sidebar email-view-sidebar items-no-padding"
      v-model="isSidebarActive"
      position-right
    >
      <div class="mail-sidebar-content px-0 pb-4 h-full" v-if="currentMail">
        <div
          class="
            flex flex-wrap
            items-center
            email-header
            justify-between
            md:px-8
            px-6
            sm:pb-2 sm:
            pt-6
            d-theme-dark-bg
          "
        >
          <div class="flex mb-4 flex-col">
            <div class="flex items-center">
              <feather-icon
                :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                @click="$emit('closeSidebar')"
                class="cursor-pointer mr-4"
                svg-classes="w-6 h-6"
              ></feather-icon>
              <h4 v-if="currentMail.subject">{{ currentMail.subject }}</h4>
              <h4 v-else>(no subject)</h4>
            </div>
          </div>

          <div class="flex items-center ml-10 mb-4 mt-1">
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              class="inline-flex cursor-pointer mr-5"
              style="border-right: 2px solid #ccc"
            >
              <div class="flex items-center mr-5">
                <vs-avatar
                  class="m-0 border-2 border-solid border-white"
                  size="40px"
                  :color="venue.style.colorBackground"
                  :src="venue.logoUrl"
                />
                <div class="flex items-center">
                  <h6 class="ml-2">{{ venue.name }}</h6>
                  <feather-icon icon="ChevronDownIcon" class="w-3 h-3" />
                </div>
              </div>
              <vs-dropdown-menu style="z-index: 40001" class="p-4">
                <span class="h-4 flex items-center">
                  <feather-icon icon="PhoneIcon" svgClasses="w-3 h-3'"></feather-icon>
                  <span class="ml-2 text-sm"> {{ venue.phoneCountryCode }}{{ venue.phone }} </span>
                </span>
                <span class="h-4 flex items-center">
                  <feather-icon icon="MailIcon" svgClasses="w-3 h-3'"></feather-icon>
                  <span class="ml-2 text-sm">
                    {{ venue.email }}
                  </span>
                </span>
                <span class="h-4 flex items-center">
                  <feather-icon icon="GlobeIcon" svgClasses="w-3 h-3'"></feather-icon>
                  <span class="ml-2 text-sm">
                    <a :href="'https://' + venue.website" target="_blank">https://{{ venue.website }}</a>
                  </span>
                </span>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-chip :color="currentMail.guestId ? 'rgba(0, 100, 0, 0.3)' : 'rgba(100, 0, 0, 0.3)'">
              <div
                class="relative flex items-center cursor-pointer"
                @click.stop="$emit('showProfileSidebar', currentMail.id)"
              >
                <h6 class="mr-2">{{ currentMail.guestEmailName }}</h6>

                <!-- Show UserCheckIcon if found -->
                <!-- Show UserXIcon if not found -->
                <feather-icon
                  :icon="currentMail.guestId ? 'UserCheckIcon' : 'UserXIcon'"
                  svgClasses="w-6 h-6 text-dark"
                ></feather-icon>
              </div>
            </vs-chip>
          </div>
        </div>
        <div class="overflow-y-auto h-full p-8">
          <div v-if="isSidebarActive" style="margin-bottom: 240px">
            <!-- ALL MESSAGES - THREAD -->
            <div class="vx-row" v-for="threadMail in currentMail.messages.slice()" :key="threadMail.id">
              <div class="vx-col w-full">
                <email-mail-card :mailContent="threadMail" :conversation="currentMail" class="mb-10" />
              </div>
            </div>
            <!-- Input fields -->
            <div class="mb-8 absolute bottom-0 left-0 mx-3" style="right: 16px">
              <send-area
                type="email"
                :activeConversation="currentMail"
                @onSendMessage="replyTo"
                ref="sendArea"
              />
            </div>
          </div>
        </div>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import EmailMailCard from "./EmailMailCard.vue";
import SendArea from "../Components/SendArea.vue";

export default {
  components: {
    SendArea,
    VuePerfectScrollbar,
    EmailMailCard,
  },
  props: {
    openMailId: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5,
      },
    };
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit("closeSidebar");
        setTimeout(() => {
          this.showThread = false;
        }, 500);
      }
    },
  },
  computed: {
    currentMail() {
      return this.$store.getters["email/conversation"](this.openMailId);
    },
    venue() {
      return this.$store.getters["venues/venue"](this.currentMail.venueId);
    },
  },
  methods: {
    async replyTo(typedMessage) {
      if (!typedMessage) return;

      this.$vs.loading({ text: "Sending email..." });
      try {
        const payload = {
          venueId: this.currentMail.venueId,
          venueEmail: this.currentMail.venueEmail,
          replyToMessageId: this.$store.getters["email/conversationLastMessage"](this.openMailId).messageId,
          text: typedMessage,
        };
        console.log("Sending message", payload);
        await this.$store.dispatch("email/sendMessage", payload);

        // Clear send area
        this.$refs.sendArea.messageSent();

        this.$vs.notify({
          color: "green",
          title: "Email sent",
          text: "Email sent",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Email could not be sent",
          text: "Error sending email",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    toggleIsStarred() {
      const payload = {
        mailId: this.openMailId,
        value: !this.currentMail.isStarred,
      };
      //this.$store.dispatch('email/toggleIsMailStarred', payload)
    },
    moveTo(to) {
      this.$emit("closeSidebar");
      this.$emit("moveTo", to);
    },
  },
};
</script>

